<script>

import moment from 'moment'
import {
  formatPriceWithSign
} from '@/utils/helpers'
import Documents from '@/components/orders/views/Documents.vue'
import chatIcon from '@/assets/images/icons/chat.svg?inline'
import chatFilledIcon from '@/assets/images/icons/chat-filled.svg?inline'
import filesIcon from '@/assets/images/icons/files.svg?inline'
import paymentIcon from '@/assets/images/icons/payment.svg?inline'
import starIcon from '@/assets/images/icons/star.svg?inline'

export default {
  name: 'orders-table',
  components: {
    Documents,
    chatIcon,
    filesIcon,
    paymentIcon,
    starIcon,
    chatFilledIcon
  },
  data: () => ({
    documentsModal: {
      isActive: false,
      orderId: null,
      collection: []
    }
  }),
  computed: {
    isLoading() {
      return this.$store.getters['orders/isLoading']
    },
    collection() {
      return this.$store.getters['orders/getCollection']
    },
    includes() {
      return this.$store.getters['orders/getIncludes']
    }
  },
  methods: {
    formatDate: (date, format) => moment.unix(date).format(format),
    getStatusName(statusId) {
      return this.includes.statuses[statusId]
    },
    formatPrice(amount, currencySlug) {
      const dictionary = this.$store.getters.getDictionary('orders.dictionaries.currencies')

      return formatPriceWithSign(amount, currencySlug, dictionary)
    },
    openPaymentMethodSelectForm({ paymentHash, orderId, price }) {
      this.$store.commit('payment/setMethodSelectForm', {
        sum: price.amount,
        isActive: true,
        orderId
      })

      this.$store.commit('payment/setBillingData', {
        paymentHash
      })

      const collection = this.$store.getters['payment/methodSelectForm'].paymentSuppliers

      if (!collection.length) {
        this.$store.commit('payment/setMethodSelectForm', {
          isLoading: true
        })

        this.$store.dispatch('payment/getSuppliers')
      }
    },
    openDocumentsModal(collection, orderId) {
      if (collection.length) {
        this.documentsModal = {
          isActive: true,
          orderId,
          collection
        }
      }
    },
    getVouchersCountLabel(vouchersCollection) {
      return vouchersCollection.length
        ? `Документов по заказу: ${vouchersCollection.length}`
        : 'Документов по заказу нет'
    }
  }
}
</script>
<template>
  <div>
    <div class="orders-table content-table">
      <b-table
        v-if="collection.length"
        :data="collection"
        :row-class="(row, index) => 'orders-table__row'"
        :hoverable="true"
      >
        <template slot-scope="props">
          <b-table-column label="Заказ">
            <template
              slot="header"
              slot-scope="{ column }"
            >
              <span class="orders-table__header-order">{{ column.label }}</span>
            </template>
            <div class="orders-table__content-cell orders-table__order">
              <div class="orders-table__order-status" />
              <div class="orders-table__order-details">
                <router-link
                  :to="{
                    name: 'Order',
                    params:{
                      orderId: props.row.orderId
                    }
                  }"
                  class="orders-table__order-number orders-table__cell-details"
                >
                  {{ props.row.orderId }}
                </router-link>
                <div class="orders-table__country orders-table__cell-details">
                  <img
                    v-if="props.row.country.flag"
                    class="orders-table__country-flag"
                    :src="props.row.country.flag"
                  >
                  <p class="orders-table__country-name">
                    {{ props.row.country.name }}
                  </p>
                </div>
                <p
                  class="orders-table__tourist orders-table__cell-details"
                >
                  {{ props.row.mainTouristSurname }}
                </p>
              </div>
            </div>
          </b-table-column>
          <b-table-column
            label="Отель"
            :width="240"
          >
            <div class="orders-table__content-cell orders-table__hotel">
              <p class="orders-table__hotel-dates orders-table__cell-details">
                {{
                  `${formatDate(props.row.dates.start, 'DD.MM')}
                  -${formatDate(props.row.dates.end, 'DD.MM')}`
                }}
              </p>
              <div class="orders-table__hotel-details orders-table__cell-details">
                <p
                  v-if="props.row.hotel.name"
                  class="orders-table__hotel-name"
                >
                  {{ props.row.hotel.name }}
                </p>
                <div
                  v-if="props.row.hotel.name"
                  class="orders-table__hotel-category"
                >
                  <star-icon
                    v-for="(star, starIndex) in props.row.hotel.stars"
                    :key="`order${props.row.orderId}-star${starIndex}`"
                    fill="#F8CE46"
                  />
                </div>
              </div>
            </div>
          </b-table-column>
          <b-table-column
            :width="56"
            centered
          >
            <template slot="header">
              <chat-icon
                class="orders-table__header-icon"
              />
            </template>
            <div class="orders-table__content-cell orders-table__chat">
              <div class="">
                <div
                  v-if="props.row.unreadMessagesCount"
                  class="orders-table__chat-icon"
                  :class="{
                    'orders-table__chat-icon--new-messages': props.row.unreadMessagesCount
                  }"
                  :data-count="props.row.unreadMessagesCount"
                >
                  <chat-filled-icon />
                </div>
                <div
                  v-else
                  class="orders-table__chat-icon"
                >
                  <chat-icon />
                </div>
              </div>
            </div>
          </b-table-column>
          <b-table-column label="Ведущий менеджер">
            <div class="orders-table__content-cell orders-table__manager">
              <p class="orders-table__manager-name orders-table__cell-details">
                {{ props.row.managers.leader }}
              </p>
              <p class="orders-table__manager-office orders-table__cell-details">
                {{ `${props.row.managers.agency}, ${props.row.managers.name}` }}
              </p>
            </div>
          </b-table-column>
          <b-table-column
            :width="100"
            label="Сумма"
          >
            <div class="orders-table__common orders-table__common--right">
              <p>{{ formatPrice(props.row.price.amount, props.row.price.currency) }}</p>
            </div>
          </b-table-column>
          <b-table-column
            :width="100"
            label="Долг"
          >
            <div class="
              orders-table__common
              orders-table__common--danger
              orders-table__common--right
            "
            >
              <p>{{ formatPrice(props.row.price.debt, props.row.price.currency) }}</p>
            </div>
          </b-table-column>
          <b-table-column
            :width="100"
            label="Срок оплаты"
          >
            <div class="orders-table__common orders-table__common--centered">
              <p>{{ formatDate(props.row.dates.payment, 'DD.MM.YYYY') }}</p>
            </div>
          </b-table-column>
          <b-table-column
            label="Статус"
          >
            <div class="orders-table__common">
              <p>{{ getStatusName(props.row.status) }}</p>
            </div>
          </b-table-column>
          <b-table-column
            label="Оплата"
            :width="100"
          >
            <div class="orders-table__common">
              <p>{{ props.row.price.status }}</p>
            </div>
          </b-table-column>
          <b-table-column
            label=""
            :width="48"
          >
            <div class="orders-table__actions">
              <div class="orders-table__actions-icon">
                <payment-icon
                  fill="#55b7a1"
                  @click="openPaymentMethodSelectForm(props.row)"
                />
              </div>
              <div class="orders-table__actions-icon">
                <b-tooltip
                  :label="getVouchersCountLabel(props.row.vouchers)"
                  position="is-left"
                  class="rex-tooltip"
                  animated
                >
                  <files-icon
                    @click="openDocumentsModal(props.row.vouchers, props.row.orderId)"
                  />
                </b-tooltip>
              </div>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
    <b-modal
      :active.sync="documentsModal.isActive"
      scroll="keep"
      :width="348"
      :can-cancel="['escape', 'outside']"
    >
      <div class="card">
        <div class="modal__wrap card-content">
          <div class="modal__content">
            <div class="modal__header">
              <h2>Документы</h2>
            </div>
            <documents
              store-module="orders"
              getter-name="getField"
              setter-name="setField"
              target="documentsForm"
              :documents="documentsModal.collection"
              :order-id="documentsModal.orderId"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
